import { render, staticRenderFns } from "./vpd-markdown.vue?vue&type=template&id=15800560&"
import script from "./vpd-markdown.vue?vue&type=script&lang=js&"
export * from "./vpd-markdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports